module.exports = __webpack_public_path__ + "static/media/hero.504f902d.png";